<template>
  <div class="challenge">
    <Header
      v-bind:pageName="pageName"
      v-bind:login="login"
      v-bind:profile="profile"
      @profile="profile = $event"
      v-bind:mai="mai"
      @mai="mai = $event"
    />
    <Loading v-if="loading" />
    <div v-else>
      <ChallengeDetail
        v-bind:uid="user.uid"
        v-bind:uname="profile.name"
        v-bind:cdata="cdata"
        v-bind:chost="chost"
        v-bind:cid="cid"
      />
      <ChallengeContent
        v-bind:login="login"
        v-bind:cid="cid"
        @pickup="picked = $event"
      />
      <ChallengePopup v-bind:picked="picked" @pickup="picked = $event" />
    </div>
  </div>
</template>

<script>
import firebaseUtil from "@/firebase";
import store from "@/store";
// @ is an alias to /src
import Header from "@/components/modules/header";
import Loading from "@/components/parts/Loading";
import ChallengeDetail from "@/components/modules/ChallengeDetail";
import ChallengeContent from "@/components/modules/ChallengeContent";
import ChallengePopup from "@/components/modules/ChallengePopup";

export default {
  components: {
    Header,
    Loading,
    ChallengeDetail,
    ChallengeContent,
    ChallengePopup,
  },
  data() {
    return {
      pageName: "チャレンジ",
      login: false,
      user: {},
      provider: {},
      profile: {},
      mai: {},
      loading: true,
      cid: this.$route.params["cid"],
      cdata: {},
      chost: {},
      picked: null,
    };
  },
  created() {
    let myPromise1 = new Promise((resolve) => {
      firebaseUtil.onAuth("challenge").then(() => {
        resolve();
      });
    });
    myPromise1.then(() => {
      this.user = store.getters.user;
      if (!this.user.state) {
        this.user = "";
        this.loading = false;
      } else {
        for (let i = 0; i < this.user.providerData.length; i++) {
          if (this.user.providerData[i].providerId == "twitter.com") {
            this.provider.twitter = true;
          } else {
            this.provider.google = true;
          }
        }
        this.login = true;
        // challengeのデータを取ってくる
        // https://qiita.com/turmericN/items/b849ebe8313d863855b1
        firebaseUtil.getChallenge(this.cid).then((data) => {
          this.cdata = data;
          this.pageName = data.data.name;
          console.log(this.cdata);
          firebaseUtil.getOtherProfile(this.cdata.host).then((data) => {
            this.chost = data;
            this.loading = false;
            console.log(this.chost);
          });
        });
      }
    });
  },
};
</script>
